import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

import { ToDoPriority } from "../../TasksAndSubTasks/enum/ToDoPriority.enum";

const { REQUIRED } = ERROR_TYPE;

export const SubTaskTemplateInfoSchema = z.object({
	id: z.number().optional(),
	title: z.string().min(1, { message: REQUIRED }).trim(),
	description: z.string().optional().nullable(),
	priority: z.nativeEnum(ToDoPriority).optional().nullable(),
	tagId: z.number().optional().nullable(),
	complexityEstimate: z.number().optional().nullable(),
	order: z.number().optional(),
	taskTemplateId: z.number().optional(),
	createdAt: z.string().optional(),
	updatedAt: z.string().optional(),
	deletedAt: z.string().optional().nullable(),
});

export const TaskTemplateInfoSchema = z.object({
	id: z.number().optional(),
	title: z.string().min(1, { message: REQUIRED }).trim(),
	description: z.string().optional().nullable(),
	priority: z.nativeEnum(ToDoPriority).optional().nullable(),
	tagId: z.number().optional().nullable(),
	complexityEstimate: z.number().optional().nullable(),
	order: z.number().optional(),
	createdAt: z.string().optional(),
	updatedAt: z.string().optional(),
	deletedAt: z.string().optional().nullable(),
	subTaskTemplates: z.array(SubTaskTemplateInfoSchema).optional(),
});

export const CreateTaskTemplateSchema = z.object({
	title: z.string().min(1, { message: REQUIRED }).trim(),
	description: z.string().optional().nullable(),
	priority: z.nativeEnum(ToDoPriority).optional().nullable(),
	tagId: z.number().optional().nullable(),
	complexityEstimate: z.number().optional().nullable(),
});

export const UpdateTaskTemplateSchema = z.object({
	id: z.number(),
	title: z.string().min(1, { message: REQUIRED }).trim(),
	description: z.string().optional().nullable(),
	priority: z.nativeEnum(ToDoPriority).optional().nullable(),
	tagId: z.number().optional().nullable(),
	complexityEstimate: z.number().optional().nullable(),
	order: z.number().optional(),
});

export const CreateSubTaskTemplateSchema = z.object({
	taskTemplateId: z.number(),
	title: z.string().min(1, { message: REQUIRED }).trim(),
	description: z.string().optional().nullable(),
	priority: z.nativeEnum(ToDoPriority).optional().nullable(),
	tagId: z.number().optional().nullable(),
	complexityEstimate: z.number().optional().nullable(),
});

export const UpdateSubTaskTemplateSchema = z.object({
	id: z.number(),
	taskTemplateId: z.number(),
	title: z.string().min(1, { message: REQUIRED }).trim(),
	description: z.string().optional().nullable(),
	priority: z.nativeEnum(ToDoPriority).optional().nullable(),
	tagId: z.number().optional().nullable(),
	complexityEstimate: z.number().optional().nullable(),
	order: z.number().optional(),
});

export const DeleteResponseSchema = z.object({
	id: z.number(),
});

export const TaskTemplateArraySchema = z.array(TaskTemplateInfoSchema);

export type TaskTemplateInfo = z.infer<typeof TaskTemplateInfoSchema>;
export type SubTaskTemplateInfo = z.infer<typeof SubTaskTemplateInfoSchema>;
export type CreateTaskTemplate = z.infer<typeof CreateTaskTemplateSchema>;
export type UpdateTaskTemplate = z.infer<typeof UpdateTaskTemplateSchema>;
export type CreateSubTaskTemplate = z.infer<typeof CreateSubTaskTemplateSchema>;
export type UpdateSubTaskTemplate = z.infer<typeof UpdateSubTaskTemplateSchema>;
